import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, PrimaryButton, Tooltip, getPaymentProcessorTitle, toast, useTranslation as useUiTranslation } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { mollieDisconnect } from 'modules/profile/payment-gateways/integrations/mollie/api';
import MollieProfileModal from 'modules/profile/payment-gateways/integrations/mollie/components/mollie-profile-modal';
import { MolliePaymentIntegrationInterface, PaymentMollieProfileInterface } from 'modules/profile/payment-gateways/integrations/mollie/types';
import { getMollieHelpPageLink } from 'modules/profile/payment-gateways/integrations/mollie/utils';
import { isDesiredIntegration } from 'modules/profile/payment-gateways/utils/is-desired-integration';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon, MollieLogoIcon, WarningIcon } from '@systemeio/ui/icons';
export const Mollie: FC = () => {
  const $ = _c(15);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    getConnectedPaymentIntegration,
    mutatePaymentIntegrations,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== deleteOpened || $[1] !== getConnectedPaymentIntegration || $[2] !== mutatePaymentIntegrations || $[3] !== removePaymentIntegration || $[4] !== t || $[5] !== tUi || $[6] !== user?.dashboardLocale) {
    const title = getPaymentProcessorTitle(PaymentProcessorEnum.Mollie, tUi);
    let t1;
    if ($[8] !== getConnectedPaymentIntegration) {
      t1 = getConnectedPaymentIntegration({
        processor: PaymentProcessorEnum.Mollie
      });
      $[8] = getConnectedPaymentIntegration;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    const mollieIntegration = t1;
    let t2;
    if ($[10] !== mutatePaymentIntegrations) {
      t2 = async newData => {
        await mutatePaymentIntegrations(data => {
          if (data) {
            return data.map(integration => {
              if (isDesiredIntegration(integration, PaymentProcessorEnum.Mollie)) {
                return {
                  ...integration,
                  details: {
                    ...integration.details,
                    profileId: newData.id,
                    profileName: newData.name
                  }
                };
              }
              return integration;
            });
          }
        }, false);
      };
      $[10] = mutatePaymentIntegrations;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    const onMollieProfileChange = t2;
    const onDelete = async () => {
      await mollieDisconnect();
      await removePaymentIntegration({
        processor: PaymentProcessorEnum.Mollie
      });
      toast.success(t("dashboard.settings.payment-gateways.account_removed", {
        payment: title
      }));
    };
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MollieLogoIcon />;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    const t4 = user?.dashboardLocale;
    let t5;
    if ($[13] !== t4) {
      t5 = getMollieHelpPageLink(t4);
      $[13] = t4;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t0 = <Integration logo={t3} additionalInfo={<a className="primary-link" href={t5} target="_blank" rel="noreferrer"><TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={{
        integration: title
      }} /></a>}>{mollieIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!mollieIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}<p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.organization_name")}:`}</span><span className="text-text-primary truncate">{mollieIntegration.details.organizationName}</span></p><p className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.organization_email")}:`}</span><span className="text-text-primary truncate">{mollieIntegration.details.organizationEmail}</span></p><div className="flex items-center gap-1 text-base lg:text-lg"><span>{`${t("dashboard.settings.payment-gateways.mollie_profile")}:`}</span><span className="text-text-primary truncate">{mollieIntegration.details.profileName}</span><MollieProfileModal onMollieProfileChange={onMollieProfileChange} mollieAccount={mollieIntegration.details} /></div>{!mollieIntegration.details.profileId && <p className="flex gap-1.5"><span>{t("dashboard.settings.payment-gateways.mollie_choose_profile_warning")}</span><WarningIcon /></p>}</div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
          payment: title
        })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
          payment: title
        })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.mollie")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <PrimaryButton type="button" className="font-bold" onClick={_temp}>{t("dashboard.settings.payment_gateways.connect")}</PrimaryButton>}</Integration>;
    $[0] = deleteOpened;
    $[1] = getConnectedPaymentIntegration;
    $[2] = mutatePaymentIntegrations;
    $[3] = removePaymentIntegration;
    $[4] = t;
    $[5] = tUi;
    $[6] = user?.dashboardLocale;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
};
function _temp() {
  return window.open(`/api/dashboard/customer/settings/connected-integrations/${PaymentProcessorEnum.Mollie}/auth`, "_self");
}